// extracted by mini-css-extract-plugin
export default {"table":"Kh3u0la9IUsIWXyiEDRF"};